import { render, staticRenderFns } from "./Gota.vue?vue&type=template&id=701611c8&"
import script from "./Gota.vue?vue&type=script&lang=js&"
export * from "./Gota.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports